import { render, staticRenderFns } from "./diagnose.vue?vue&type=template&id=940ac70a&scoped=true"
import script from "./diagnose.vue?vue&type=script&lang=js"
export * from "./diagnose.vue?vue&type=script&lang=js"
import style0 from "./diagnose.vue?vue&type=style&index=0&id=940ac70a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940ac70a",
  null
  
)

export default component.exports